import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 3,
      rows: 3,
      rowsSize: [1, 10, 1],
      colSpan: {
        "0:0": 3,
        "1:0": 3,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "Step1: Audible image sources up to 0-th order (direct sound).</br>Distance between sound source and receiver: 3.50 m -> Δt = 10.2 ms",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "12px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/08/principle/synthesis-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Direct sound",
                  theme: "primary",
                  icon: "cis-volume-high",
                  shape: "round",
                  size: "standard",
                  url: `${config.ASSETS_URL}/03/08/principle/direct-sound.wav`,
                },
              },
              styles: {
                justifyContent: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Up to 1st order",
                  theme: "primary",
                  icon: "cis-volume-high",
                  shape: "round",
                  size: "standard",
                  url: `${config.ASSETS_URL}/03/08/principle/first-order.wav`,
                  disabled: true,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Up to 2nd order",
                  theme: "primary",
                  icon: "cis-volume-high",
                  shape: "round",
                  size: "standard",
                  url: `${config.ASSETS_URL}/03/08/principle/second-order.wav`,
                  disabled: true,
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
